import businessIcon from "@assets/icons/business.svg";
import companyIcon from "@assets/icons/company.svg";
import servicesIcon from "@assets/icons/services.svg";
import resourcesIcon from "@assets/icons/resources.svg";
import safetyIcon from "@assets/icons/safety.svg";
import alertIcon from "@assets/icons/noun-alert-8019270 1.svg";
import callIcon from "@assets/icons/noun-call-2443021 1.svg";
import inspectIcon from "@assets/icons/noun-mechanic-4052754 1.svg";

// HEADER DATA
export const navLinks = [
  {
    title: "Company",
    subTitle: "Company & Investors",
    icon: companyIcon,
    links: [
      { title: "About Us", href: "/business/about-us" },
      { title: "Why Choose GASIS", href: "/business/why-choose-gasis" },
      {
        title: "Sustainability & Corporate Responsibility",
        href: "/business/sustainability-corporate-responsibility",
      },
      {
        title: "Investor Governance & Corporate Documentation",
        href: "/business/investor-governance-corporate",
      },
      { title: "Careers", href: "/business/careers" },
      {
        title: "Investor Relations / Corporate Profile",
        href: "/business/investor-relations",
      },
      {
        title: "News, Updates & Announcements",
        href: "/business/news-updates-announcements",
      },
      { title: "Contact", href: "/business/contact" },
    ],
  },
  {
    title: "Solutions",
    subTitle: "Business Solutions",
    icon: businessIcon,
    links: [
      {
        title: "Business Solutions & Developer Services",
        href: "/business/solutions/business-solutions-and-developer-services",
      },
      { title: "New Connection", href: "/business/solutions/new-connection" },
      { title: "Gas Services", href: "/business/solutions/gas-services" },
      {
        title: "Commercial & F&B Gas Solutions",
        href: "/business/solutions/commercial-fb-gas-solutions",
      },
    ],
  },
  {
    title: "Services & Tariffs",
    subTitle: "Services & Tariffs",
    icon: servicesIcon,
    links: [
      { title: "Tariffs", href: "/business/services/tariffs" },
      {
        title: "Online Service/Pay Bill",
        href: "/business/services/online-service-pay-bill",
      },
      {
        title: "Service Level Agreement (SLA)",
        href: "/business/services/service-level-agreement",
      },
    ],
  },
  {
    title: "Safety & Support",
    subTitle: "Safety & Support",
    icon: safetyIcon,
    links: [
      {
        title: "Safety & Emergencies",
        href: "/business/safety/safety-emergencies",
      },
      { title: "FAQs", href: "/business/safety/faqs" },
      {
        title: "Safety Guidelines & Emergency Procedures",
        href: "/business/safety/safety-guidelines",
      },
      {
        title: "Customer Feedback & Service Survey",
        href: "/business/safety/customer-feedback",
      },
    ],
  },
  {
    title: "Resources",
    subTitle: "Resources & Compliance",
    icon: resourcesIcon,
    links: [
      {
        title: "Corporate Governance, Compliance & Certifications",
        href: "/business/resources/corporate-governance",
      },
      {
        title: "Regulatory Compliance & Licensing",
        href: "/business/resources/regulatory-compliance",
      },
      {
        title: "Downloads & Resources Library",
        href: "/business/resources/resources-library",
      },
    ],
  },
];

//
// BUSINESS SOLUTION DATA

export const services = [
  {
    title: "Design & Engineering",
    desc: "Turnkey design of LPG/SNG gas distribution networks compliant with Dubai Civil Defense and ESMA standards. Includes concept layouts, load calculation, and equipment sizing. ",
  },
  {
    title: "Supply & Installation",
    desc: "Procurement and installation of storage tanks, manifolds, pressure regulators, meters, and safety devices. ",
  },
  {
    title: "Smart Metering & AMI Integration",
    desc: "Advanced Metering Infrastructure (AMI) for automated reading, consumption analytics, and leak detection. ",
  },
  {
    title: "Billing & Collection Outsourcing",
    desc: "GASIS manages tenant invoicing, payments, collection, and remittance — fully compliant with FTA and RERA requirements. ",
  },
  {
    title: "Operations, Safety & Regulatory Support",
    desc: "Comprehensive maintenance with safety checks, 24/7 emergency response, and full coordination for Civil Defense and ESMA approvals.",
  },
  {
    title: "Energy Efficiency & Retrofit",
    desc: "Upgrade of old gas systems with modern components to enhance safety and reduce losses. ",
  },
];

export const whyChooseGasis = [
  {
    title: "Single Window Solution",
    info: "One partner from design to daily operations.",
  },
  {
    title: "Transparent Billing Model",
    info: "Fixed service fee with optional revenue-sharing for billing and collection.",
  },
  {
    title: "Certified & Licensed",
    info: "Fully certified and licensed to operate in compliance with all industry and safety standards.",
  },
  {
    title: "Smart Meter Technology",
    info: "Advanced smart meters for accurate measurement, real-time monitoring, and efficient energy management.",
  },
  {
    title: "Regulatory Compliance",
    info: "Strict adherence to regulatory requirements, ensuring safe, reliable, and lawful operations.",
  },
  {
    title: "Customer Experience",
    info: "Dedicated support and seamless service delivery focused on reliability, transparency, and satisfaction.",
  },
];

export const partnership = [
  {
    title: "Turnkey EPC",
    desc: "GASIS handles full design, supply, installation, and commissioning under fixed-price EPC terms.",
  },
  {
    title: "Build-Operate-Transfer (BOT)",
    desc: "GASIS invests in infrastructure, operates it, and transfers ownership after a defined term. ",
  },
  {
    title: "Operation & Maintenance Contract",
    desc: "Developer owns assets; GASIS provides maintenance and 24/7 operations. ",
  },
  {
    title: "Billing & Collection Outsourcing",
    desc: "GASIS manages meter readings, tenant invoicing, and collection on developer’s behalf. ",
  },
];

export const features = [
  "Automated readings (daily / monthly)",
  "Cloud billing dashboard for property managers",
  "Multi-unit aggregation and individual invoicing",
  "Exportable reports for accounting and VAT filing",
  "Optional online payment gateway integration",
];

export const collectionServiceDetails = [
  {
    title: "Transparent Billing & Collection",
    desc: "Fixed charge per tenant invoice issued -",
    charged: "Per invoice",
    bgColor: "#851700",
  },
  {
    title: "Smart Meter Connection Fee",
    desc: "Activation per unit ",
    charged: "One-time",
    bgColor: "#C9E0FF",
  },
  {
    title: "Collection & Processing ",
    desc: "Payment collection and reconciliation",
    charged: "Monthly",
    bgColor: "#F24D2B",
  },
  {
    title: "Statement of Account / Reporting ",
    desc: "Downloadable SOA reports",
    charged: "Monthly",
    bgColor: "#F24D2B",
  },
  {
    title: "Late Payment Reminder ",
    desc: "SMS/email notification system ",
    charged: "As applicable",
    bgColor: "#62636C",
  },
];

export const keyIndustryServed = [
  {
    title: "Real Estate Developers ",
    desc: "Residential towers, villa communities",
  },
  {
    title: "Hospitality, Retail and F&B",
    desc: "Hotels, resorts, restaurants, cafés, bakeries, malls ",
  },
  {
    title: "Government / Public Sector ",
    desc: "Schools, hospitals, municipal buildings ",
  },
  {
    title: "Industrial Facilities ",
    desc: "Factories, warehouses ",
  },
];

//
// NEW CONNECTION DATA

export const workSteps = [
  {
    title: "Submit Your Application",
    desc: "Complete our online form and upload the required documents. Our team will verify your request within 24 hours. ",
  },
  {
    title: "Site Assessment & Approval",
    desc: "A GASIS engineer will inspect your premises to ensure safety and compliance with UAE regulations. ",
  },
  {
    title: "Installation & Testing ",
    desc: "Our certified technicians install and test the gas network and meters with Civil Defense standards. ",
  },
  {
    title: "Connection Activation ",
    desc: "Once approved, your gas supply is activated and a billing account is created automatically. ",
  },
];

export const whoCanApply = [
  {
    title: "Residential Units",
    desc: "Apartments and villas with LPG or SNG systems ",
  },
  {
    title: "Commercial Clients",
    desc: "Restaurants, cafés, bakeries, and laundries ",
  },
  {
    title: "Industrial Facilities",
    desc: "Factories and manufacturing plants ",
  },
];

export const requireDocuments = [
  {
    title: "Individual",
    desc: "Emirate ID (copy front & back)",
  },
  {
    title: "Tenant / Owner",
    desc: "Tenancy Contract or Title Deed",
  },
  {
    title: "Business / Commercial",
    desc: "Trade License",
  },
  {
    title: "Developer / Facility",
    desc: "Layout drawing / as built plan",
  },
  {
    title: "Others",
    desc: "NOC from Landlord(if tenant) or Building Management",
  },
];

export const platformFee = [
  {
    title: "Security Deposit",
    price: "500 - 1500 AED",
    desc: "Refundable deposit based on unit type",
  },
  {
    title: "Connection/Installation fee",
    price: "800 - 2000 AED",
    desc: "One-time charge based on meter size & pipe length",
  },
  {
    title: "Inspection and testing fee",
    price: "250 - 400 AED",
    desc: "Includes safety inspection & certification ",
  },
  {
    title: "Annual Maintenance",
    price: "200 - 500 AED",
    desc: "Regular safety checks & support ",
  },
];

export const processList = [
  {
    title: "Application Review",
    desc: "Document verification by customer service",
    duration: "Within 24 hours",
  },
  {
    title: "Site Visit / Inspection",
    desc: "Safety assessment by engineer",
    duration: "2-3 working days",
  },
  {
    title: "Installation & Testing",
    desc: "Equipment installation & Civil Defense approval",
    duration: "3-5 working days",
  },
  {
    title: "Connection Activation",
    desc: "Meter setup + account creation",
    duration: "1 working day",
  },
];

//
// COMMERCIAL GAS SOLUTION DATA
export const whyChoose = [
  {
    title: "Dubai Civil Defense (DCD) Approvals",
    desc: "We follow strict Dubai Civil Defense and ESMA standards. Your system is safe, leak-free, and built for high-demand usage.",
  },
  {
    title: "Fast Emergency Response – 24/7",
    desc: "Gas leaks can shut down your business. We guarantee: 60 mins in Dubai, 90 mins in Sharjah & Ajman, 120 mins in Abu Dhabi.",
  },
  {
    title: "Full Compliance for Kitchens & Food Facilities",
    desc: "We ensure your business meets all safety codes including DCD Fire & Life Safety, ESMA compliance, solenoid valve integration, and more.",
  },
  {
    title: "Smart Metering for Accurate Billing",
    desc: "No more disputes. Your consumption is measured precisely using smart meters with remote reading capability.",
  },
  {
    title: "24/7 Customer Support & Technical Assistance",
    desc: "Restaurants operate beyond normal business hours — so do we. Technical assistance available around the clock.",
  },
  {
    title: "Minimal Disruption Installation",
    desc: "We work with your operating hours to avoid downtime and keep your business running smoothly.",
  },
];

export const commercialBillingSolution = [
  {
    title: "Smart Metered Billing",
    desc: "Precise consumption tracking",
  },
  {
    title: "Automated Invoicing",
    desc: "Hassle-free monthly bills",
  },
  {
    title: "Online Payments & Portal",
    desc: "Pay anytime, anywhere",
  },
  {
    title: "Consumption Analytics",
    desc: "Track your usage patterns",
  },
  {
    title: "Collection of Payments",
    desc: "Streamlined payment collection",
  },
  {
    title: "Monthly Financial Reports",
    desc: "Clear financial insights",
  },
];

//
// GAS SERVICES DATA
export const gasServices = [
  {
    title: "Comfort and Safety for Every Home.",
    desc: "Our residential gas services are engineered for convenience and safety. Whether you live in a villa or an apartment tower, GASIS provides a reliable source of energy for cooking, heating, and everyday needs. ",
    type: "Residential Gas Supply",
    link: "#",
  },
  {
    title: "High-Performance Energy for High-Demand Environments.",
    desc: "From fine-dining restaurants to industrial factories, GASIS delivers large-scale, high-capacity gas systems tailored to your operational needs — ensuring compliance, efficiency, and uninterrupted service.",
    type: "Commercial & Industrial Gas Systems ",
    link: "#",
  },
  {
    title: "Regular Inspections. Reliable Systems. Peace of Mind. ",
    desc: "Safety is at the heart of every GASIS operation. Our certified technicians provide scheduled maintenance and quick-response services that keep your gas system safe, efficient, and compliant with UAE regulations. ",
    type: "Maintenance & Safety Services ",
    link: "#",
  },
];

export const gasSolutions = [
  {
    title: "Design & Consultancy",
    desc: "End-to-end gas network planning for new developments ",
  },
  {
    title: "Bulk LPG Storage Systems",
    desc: "For commercial kitchens, hospitals, and factories ",
  },
  {
    title: "Metering & Billing Integration",
    desc: "For owner associations and property managers",
  },
  {
    title: "Energy Optimization Audits",
    desc: "Improve efficiency, reduce wastage, and enhance safety ",
  },
];

// PAY BILLS SECTION
export const payBillSteps = [
  {
    title: "Pay Your Gas Bill Securely",
    desc: "GASIS offers a secure, fast, and transparent online payment system. You can pay your gas bill anytime using credit or debit card, Apple Pay, or bank transfer.",
    link: "Go to payment page",
  },
  {
    title: "Instant Bill Payment Without Logging In",
    desc: "Enter your Account or Invoice Number and make a one-time payment securely. Perfect for tenants or quick settlements.",
    link: "Pay Instantly",
  },
  {
    title: "Submit Your Meter Reading in Seconds",
    desc: "Submitting your meter reading regularly ensures your bills reflect your exact consumption. You can enter the reading manually or upload a clear photo of your meter display.",
    link: "Submit Reading",
  },
];

// TARRIFS DATA
export const tarrifs = [
  {
    title: "Restaurants / Cafés",
    price: "34.00 AED/m³",
    desc: "Includes standard safety audit",
  },
  {
    title: "Hotels / Central Kitchens",
    price: "32.00 AED/m³",
    desc: "Bulk and consistent load",
  },
  {
    title: "Retail Shops / Outlets",
    price: "33.00 AED/m³",
    desc: "Typical for F&B kiosks",
  },
  {
    title: "Industrial / Factory Supply",
    price: "30.00 AED/m³",
    desc: "Large-volume tariff",
  },
  {
    title: "Community / Developer Bulk",
    price: "29.00 AED/m³",
    desc: "Custom pricing per contract",
  },
];

export const standardMonthlyFee = [
  {
    title: "Monthly Service Charge (Billing & Meter Maintenance)",
    desc: "Covers billing, collection, portal access, and meter maintenance",
    charged: "Monthly",
    bgColor: "#F24D2B",
    textColor: "white",
  },
  {
    title: "Smart Meter Connection Fee ",
    desc: "Applies on initial activation of smart meter ",
    charged: "One-time",
    bgColor: "#C9E0FF",
    textColor: "black",
  },
  {
    title: "Account Setup / Administration Fee ",
    desc: "Payable upon new account registration or move-in ",
    charged: "One-time",
    bgColor: "#C9E0FF",
    textColor: "black",
  },
  {
    title: "Late Fee Payment",
    desc: "Applied automatically to overdue payments ",
    charged: "Per invoice",
    bgColor: "#851700",
    textColor: "white",
  },
  {
    title: "Security Deposit ",
    desc: "Refundable upon final settlement ",
    charged: "One-time",
    bgColor: "#C9E0FF",
    textColor: "black",
  },
  {
    title: "Final Bill Processing Fee ",
    desc: "Applied when closing an account",
    charged: "One-time",
    bgColor: "#C9E0FF",
    textColor: "black",
  },
  {
    title: "Reconnection Fee ",
    desc: "After default, arrears, or safety disconnection ",
    charged: "As applicable",
    bgColor: "#62636C",
    textColor: "white",
  },
  {
    title: "Disconnection Fee (Voluntary) ",
    desc: "For customer-requested disconnection ",
    charged: "As applicable",
    bgColor: "#62636C",
    textColor: "white",
  },
  {
    title: "Urgent Call-Out / False Alarm Fee ",
    desc: "Non-LPG or false emergency call",
    charged: "As applicable",
    bgColor: "#62636C",
    textColor: "white",
  },
  {
    title: "Special Inspection Fee (Non-Routine) ",
    desc: "For off-cycle inspections requested by customer ",
    charged: "As applicable",
    bgColor: "#62636C",
    textColor: "white",
  },
  {
    title: "NOC / Clearance Letter ",
    desc: "For move-out or ownership transfer ",
    charged: "As applicable",
    bgColor: "#62636C",
    textColor: "white",
  },
  {
    title: "Returned Cheque Fee / Bank Charge ",
    desc: "All bank and gateway fees borne by customer ",
    charged: "Per transaction",
    bgColor: "#851700",
    textColor: "white",
  },
];

export const securityDeposits = [
  {
    title: "Studio / Retail Kiosk",
    price: "250",
  },
  {
    title: "1 Bedroom",
    price: "300",
  },
  {
    title: "2 Bedrooms",
    price: "400",
  },
  {
    title: "3 Bedrooms",
    price: "500",
  },
  {
    title: "Penthouse / Retail Outlet",
    price: "1,000",
  },
];

export const correctionFactorsData = [
  {
    "Pressure (mbar)": "37 - 300",
    "Pressure (PSIG)": "0.5",
    Range: "Low Pressure",
    "Correction Factor": "1.0",
  },
  {
    "Pressure (mbar)": "300 – 350",
    "Pressure (PSIG)": "5",
    Range: "Medium Pressure",
    "Correction Factor": "1.3",
  },
  {
    "Pressure (mbar)": "700",
    "Pressure (PSIG)": "10",
    Range: "High Pressure",
    "Correction Factor": "1.65",
  },
  {
    "Pressure (mbar)": "1000 (1 bar)",
    "Pressure (PSIG)": "15",
    Range: "High Pressure",
    "Correction Factor": "1.9",
  },
];

export const billBreakdown = [
  {
    Component: "Gas Consumption",
    Description: "10 m³ × 35 AED",
    "Example (AED)": "350.00",
  },
  {
    Component: "Billing & Meter Maintenance Fee",
    Description: "Fixed",
    "Example (AED)": "20.00",
  },
  {
    Component: "Smart Meter Connection Fee (one-time)",
    Description: "Fixed",
    "Example (AED)": "25.00",
  },
  {
    Component: "VAT (5%)",
    Description: "Applied on total",
    "Example (AED)": "19.75",
  },
];

// FAQS DATA
export const quickAccessLinks = [
  {
    title: "Pay for gas bill ",
    desc: "Pay bills",
  },
  {
    title: "Understand my bill ",
    desc: "Billing Explainer",
  },
  {
    title: "Submit my meter reading ",
    desc: "Submit Reading",
  },
  {
    title: "I’m moving in or out",
    desc: "Fill form",
  },
  {
    title: "I want to report a leak ",
    desc: "Report Emergency",
  },
];

// SAFETY AND EMERGENCY
export const doThisRightAway = [
  "Turn off all gas appliances and main valve if accessible.",
  "Open windows and doors to ventilate the area.",
  "Evacuate everyone from the premises.",
  "Call our 24/7 Emergency Hotline 800-GASIS (42747) from a safe distance.",
  "If needed, contact Civil Defense (997).",
];

export const doNot = [
  "Don't ignite matches or lighters.",
  "Switch on/off any electrical devices.",
  "Do not use mobile phones near the leak site.",
  "Don't attempt to repair the leak yourself.",
];

export const emergencySteps = [
  {
    icon: alertIcon,
    title: "Detect Gas Smell or Alarm",
    desc: "Evacuate immediately.",
  },
  {
    icon: callIcon,
    title: "Call 800-GASIS",
    desc: "Our response team arrives within minutes in Dubai / Sharjah.",
  },
  {
    icon: inspectIcon,
    title: "Technician Inspection & Repair",
    desc: "Leak located, tested, and service restored after approval.",
  },
];

export const homeSafetyCategories = [
  {
    title: "Kitchen",
    desc: "Keep flames under supervision, ensure burner jets are clean, never leave pans unattended. ",
  },
  {
    title: "Ventilation",
    desc: "Keep windows slightly open after cooking to allow gas dissipation.",
  },
  {
    title: "Pipes & Hoses",
    desc: "Inspect rubber hoses for cracks; replace if older than 2 years. ",
  },
  {
    title: "Cylinders",
    desc: "Store upright in well-ventilated areas away from heat. ",
  },
  {
    title: "Children Safety",
    desc: "Install knob guards and teach basic gas safety rules. ",
  },
];

export const preventionPoints = [
  "Annual Safety Inspection Program for residential and commercial sites.",
  "Leak detection using digital sensors and foam testing.",
  "Replacement of aged valves, regulators, and hoses.",
  "Comprehensive Safety Audit Report issued after each visit.",
];

export const safetyResources = [
  {
    title: "Home Gas Safety Checklist",
    desc: "Quick guide for residential users.",
  },
  {
    title: "Commercial Safety Audit Template",
    desc: "Quick guide for facility managers.",
  },
];

// ─── CustomerFeedback page data ─────────────────────────────────────────────

export const whyShareFeedback = [
  {
    title: "Service Improvement",
    desc: "Your insights help us refine our daily operations and customer experience.",
  },
  {
    title: "Faster Issue Resolution",
    desc: "Direct feedback alerts us to recurring concerns that need priority attention.",
  },
  {
    title: "Better Digital Tools",
    desc: "Feedback drives improvements to our website, portal, and mobile app.",
  },
  {
    title: "Enhanced Safety & Reliability",
    desc: "Reporting safety concerns helps us maintain the highest standards.",
  },
];

export const whatYouCanReview = [
  {
    title: "Billing & Payments",
    points: [
      "Accuracy of bills",
      "Payment convenience",
      "Billing cycle clarity",
      "Online payment experience",
    ],
  },
  {
    title: "Technical Support",
    points: [
      "Response time",
      "Issue resolution quality",
      "Knowledge of technicians",
    ],
  },
  {
    title: "Customer Service",
    points: [
      "Friendliness & professionalism",
      "Phone support experience",
      "WhatsApp & online chat support",
    ],
  },
  {
    title: "Maintenance & Emergency Response",
    points: [
      "Speed of emergency handling",
      "Professionalism of field team",
      "Inspection & maintenance quality",
    ],
  },
  {
    title: "New Connection Process",
    points: [
      "Application clarity",
      "Document requirements",
      "Installation efficiency",
    ],
  },
  {
    title: "Website & Mobile App Experience",
    points: [
      "Ease of navigation",
      "Portal login & dashboard",
      "Feature usability",
      "Overall satisfaction",
    ],
  },
];

export const responseFollowUp = [
  "Your feedback is reviewed by the GASIS Customer Experience Team.",
  "Urgent issues are escalated to Technical Support or relevant departments.",
  "A response or update may be sent within 1–2 business days (if opted).",
];

// SAFETY GUIDELINES
// ─── SafetyGuidelines page data ─────────────────────────────────────────────

export const doList = [
  "Turn off the main gas valve (if accessible)",
  "Open all windows and doors for ventilation",
  "Evacuate the area immediately",
  "Call 800-GASIS (42747) from a safe location",
  "Inform building security or management",
];

export const doNotList = [
  "Do NOT turn on/off electrical switches",
  "Do NOT use lighters, candles, matches, or flames",
  "Do NOT use mobile phones inside the property",
  "Do NOT attempt to restart the gas system",
];

export const emergencyResponseTime = [
  {
    label: "Dubai",
    desc: "Within 60 minutes",
  },
  {
    label: "Sharjah / Ajman",
    desc: "Within 90 minutes",
  },
  {
    label: "Abu Dhabi (where applicable)",
    desc: "Within 2 hours",
  },
];

export const gasLeakSigns = [
  "Strong smell similar to rotten eggs (odorant added for detection)",
  "Hissing sound near pipes, valves, or meters",
  "Sudden dead plants near gas lines",
  "Weak stove flame or incomplete burning",
  "Headache, dizziness, or nausea indoors",
];

export const preventiveGuidelinesAccordion = [
  {
    title: "In the Kitchen",
    points: [
      "Keep burners clean and free of grease buildup",
      "Ensure blue flame, not yellow (yellow = incomplete combustion)",
      "Do not leave cooking unattended",
      "Keep flammable items away (cloth, tissue, oils)",
      "Never hang clothes or objects above gas stoves",
    ],
  },
  {
    title: "Gas Cylinders (if applicable)",
    points: [
      "Store cylinders upright in a well-ventilated area away from heat.",
      "Do not store more cylinders than required.",
      "Check hoses and regulators regularly for wear or cracks.",
      "Replace hoses every 2 years or per manufacturer's guidance.",
    ],
  },
  {
    title: "Piped Gas Systems",
    points: [
      "Do not tamper with or modify gas piping without a licensed technician.",
      "Schedule annual inspections for all piped connections.",
      "Know the location of your main shut-off valve.",
      "Report any suspected damage to pipes or fittings immediately.",
    ],
  },
  {
    title: "Smart Meter Customers",
    points: [
      "Monitor usage via the GASIS portal or mobile app regularly.",
      "Report sudden spikes in consumption to our support team.",
      "Ensure smart meter is accessible and not obstructed.",
      "Update contact details so alerts are received promptly.",
    ],
  },
];

export const annualSafetyChecklist = [
  "Full leak check",
  "Pressure testing",
  "Regulator calibration",
  "Valve & hose inspection",
  "Combustion check for appliances",
  "Civil Defense compliance checklist",
  "Issuance of safety report (digital PDF)",
];

export const safeUseCategories = [
  {
    title: "Stoves & Cookers",
    points: [
      "Ensure proper ventilation in kitchens.",
      "Install extractor fan or hood.",
      "Use ESMA-certified appliances only",
    ],
  },
  {
    title: "Water Heaters (Geysers)",
    points: [
      "Install only in well-ventilated areas.",
      "Never install gas heaters inside bedrooms or bathrooms.",
      "Regularly check exhaust flues for blockage.",
    ],
  },
  {
    title: "Barbecue Grills",
    points: [
      "Use only in fully ventilated outdoor areas.",
      "Keep at least 2 meters away from buildings.",
    ],
  },
];

export const afterEmergencyLeakSteps = [
  "Do NOT relight or restart any gas system",
  "Wait for GASIS technicians to assess the site",
  "Allow full testing and clearance",
  "Receive confirmation SMS/email before using gas again",
  "Log in to your portal to view the safety report",
];

export const fireExplosionTips = [
  "Install smoke and gas detectors (recommended by Civil Defense)",
  "Keep fire extinguishers (Class B/C) accessible",
  "Train household members or staff on how to close gas valves",
  "Avoid overfilling pots (boil-overs can extinguish gas flame)",
  "Ensure chimney/flue exhausts are open when using gas heaters",
];

export const downloadableSafetyResources = [
  {
    title: "Gas Safety Guide (PDF)",
    desc: "Quick guide for residential users.",
  },
  {
    title: "Emergency Procedures Sheet",
    desc: "Step-by-step emergency action guide.",
  },
  {
    title: "Commercial Kitchen Safety Checklist",
    desc: "Quick guide for facility managers.",
  },
  {
    title: "Annual Inspection Service Report",
    desc: "Template for post-inspection documentation.",
  },
  {
    title: "Pressure Testing One Guide/Tips",
    desc: "Technical reference for testing procedures.",
  },
];

// REGULATORY COMPLIANCE
// ─── RegulatoryCompliance page data ─────────────────────────────────────────
// Add these exports to your existing ../data file
// NOTE: complianceFrameworkAccordion uses JSX content inline.
// Since the accordion content is rich (sub-headings, coloured labels, nested lists),
// it is passed as JSX children directly in the data array.

export const complianceFrameworkAccordion = [
  {
    title: "Our Compliance Framework",
    sections: [
      {
        type: "intro",
        text: "GASIS follows a multi-layered compliance system aligned with national safety and regulatory bodies.",
      },
      {
        type: "heading",
        label: "A. Safety & Technical Compliance",
      },
      {
        type: "subheading-red",
        label: "We comply with:",
      },
      {
        type: "list",
        items: [
          "Dubai Civil Defense (DCD)",
          "UAE Fire & Life Safety Code",
          "ESMA (Emirates Authority for Standardization & Metrology)",
          "Local Authority Approvals for installation, testing, commissioning & ongoing operations",
        ],
      },
      {
        type: "subheading-red",
        label: "Compliance ensures safe operation of:",
      },
      {
        type: "list",
        items: [
          "LPG/SNG networks",
          "Gas storage & distribution systems",
          "Smart metering infrastructure",
          "Emergency response protocols",
          "Inspection & certification processes",
        ],
      },
      {
        type: "heading",
        label: "B. Financial & Commercial Compliance",
      },
      {
        type: "subheading",
        label: "GASIS is fully compliant with:",
      },
      {
        type: "list",
        items: [
          "Federal Tax Authority (FTA) for VAT registration and reporting",
          "UAE Commercial Companies Law",
          "PCI DSS standards for secure online payment processing",
          "Transparent, regulation-aligned billing practices",
          "Data Protection & Privacy",
          "All digital platforms, portals, and customer records follow UAE Federal Decree-Law No. 45 of 2021 (Personal Data Protection Law — PDPL)",
          "Mandatory data encryption at rest and in transit",
          "Access-controlled storage & audit logs",
          "Role-based security for internal users",
        ],
      },
      {
        type: "heading",
        label: "C. Data Protection & Privacy",
      },
      {
        type: "subheading",
        label: "All digital platforms, portals, and customer records follow:",
      },
      {
        type: "list",
        items: [
          "UAE Federal Decree-Law No. 45 of 2021 (Personal Data Protection Law – PDPL)",
          "Mandatory data encryption & secure transmission",
          "Access-controlled storage & audit logs",
          "Role-based security for internal users",
        ],
      },
    ],
  },
  {
    title: "Licensing & Government Registration",
    sections: [
      {
        type: "intro",
        text: "GASIS operates under the following official credentials:",
      },
      {
        type: "heading",
        label: "A. Trade License",
      },
      {
        type: "list",
        items: [
          "Gas Integrated Solutions L.L.C.",
          "License No. 1234567",
          "Issued by Dubai Department of Economy & Tourism (DET)",
          "B. Dubai Civil Defense Compliance",
        ],
      },
      {
        type: "heading",
        label: "B. Dubai Civil Defense Compliance",
      },
      {
        type: "list",
        items: ["Certified Gas Contractor"],
      },
      {
        type: "subheading",
        label: "Approved for",
      },
      {
        type: "list",
        items: [
          "Gas installation works",
          "Emergency response and maintenance",
          "Inspection & testing certification",
        ],
      },
      {
        type: "heading",
        label: "C. ESMA Certification",
      },
      {
        type: "list",
        items: [
          "Equipment & materials meeting UAE national standards",
          "Quality-verified fittings, meters, regulators, pipes, and safety devices",
        ],
      },
      {
        type: "heading",
        label: "D. VAT Registration",
      },
      {
        type: "list",
        items: [
          "Registered with the Federal Tax Authority (FTA) as a VAT-compliant entity",
          "Full compliance with VAT invoicing, reporting, and filing requirements",
        ],
      },
    ],
  },
];

export const inspectionAuditPoints = [
  "Annual DCD inspections",
  "ESMA conformity assessments",
  "Internal HSE audits",
  "Quality assurance reviews",
  "Emergency system simulations",
  "Meter verification & calibration checks",
];

export const complianceDownloads = [
  "Trade License",
  "DCD Compliance Certificates",
  "ESMA Conformity Certificates",
  "Safety Inspection Reports (project-specific)",
  "VAT Registration Certificate",
  "Insurance & Liability Coverage Summary",
  "HSE Policy & Procedures Manual",
];

export const developerAuthorityPoints = [
  "Project submissions",
  "Authority NOCs",
  "As-built approvals",
  "Compliance documentation",
  "Safety audit coordination",
  "Plan renewals",
];

// ─── CorporateGovernance page data ──────────────────────────────────────────

export const governanceFrameworkCategories = [
  {
    title: "Integrity & Ethical Conduct",
    subtitle:
      "We adhere to a strict internal Code of Conduct guiding all employees and contractors. This includes",
    points: [
      "Zero tolerance for fraud or misconduct",
      "Anti-bribery and anti-corruption standards",
      "Confidentiality rules",
      "Fair treatment of customers",
      "Ethical engineering and installation practices",
    ],
  },
  {
    title: "Regulatory Compliance",
    subtitle:
      "GASIS complies with all UAE federal and local regulations, including:",
    points: [
      "Dubai Civil Defense (DCD) – LPG/SNG System Standards",
      "ESMA – Emirates Authority for Standardization & Metrology",
      "UAE Fire & Life Safety Code of Practice",
      "FTA VAT Regulations",
      "Dubai Municipality Guidelines",
      "UAE Federal Decree-Law No. 45 of 2021 (Data Protection)",
    ],
  },
  {
    title: "Safety & Risk Management",
    subtitle: "Our internal HSE (Health, Safety & Environment) system follows:",
    points: [
      "ISO 45001 – Occupational Health & Safety Management",
      "ISO 9001 – Quality Management Standard",
      "Preventive risk assessments",
      "Annual safety audits",
      "Contractor qualification checks",
      "Detailed incident reporting and analysis",
    ],
  },
  {
    title: "Transparency & Accountability",
    subtitle: "We maintain clear reporting channels for:",
    points: [
      "Customer complaints",
      "Operational issues",
      "Compliance reviews",
      "Supplier evaluations",
      "Financial transparency",
    ],
  },
];

export const certificationsLicenses = [
  {
    title: "Dubai Civil Defense (DCD) Approvals",
    subtitle: "GASIS holds all mandatory DCD certifications for:",
    points: [
      "LPG/SNG Installation",
      "Gas Network Maintenance",
      "Annual Inspection & Testing",
      "Emergency Response",
      "Commercial Kitchen Compliance",
    ],
  },
  {
    title:
      "ESMA Compliance (Emirates Authority for Standardization & Metrology)",
    subtitle: "We use 100% ESMA-approved equipment, including:",
    points: [
      "Rubber hoses",
      "Regulators",
      "Valves",
      "Meters",
      "Manifold systems",
    ],
  },
  {
    title: "Trade License & Regulatory Registrations",
    subtitle: "GASIS holds all mandatory DCD certifications for:",
    points: [
      "Trade License No.: 1234567",
      "Registered in Dubai Economic Department",
      "TRN (Tax Registration Number)",
      "Member of Contra Group of Companies",
    ],
  },
  {
    title: "Safety & Quality Certificates",
    subtitle: "Where applicable (optional but recommended for future):",
    points: [
      "ISO 45001 (HSE)",
      "ISO 9001 (Quality)",
      "ISO 27001 (Information Security) — optional but very strong",
    ],
  },
];

export const complianceStructureColumns = [
  {
    title: "Annual Compliance Cycle",
    subtitle: "",
    points: [
      "Scheduled audits",
      "Fire & Life Safety inspections",
      "Pressure testing schedules",
      "System integrity checks",
      "Equipment calibration",
    ],
  },
  {
    title: "Documentation & Reporting",
    subtitle:
      "All compliance records are archived digitally and accessible to developers and regulatory authorities upon request.",
    points: [],
  },
  {
    title: "Third-Party Inspection",
    subtitle:
      "GASIS works with Civil Defense–approved third-party inspection companies for:",
    points: [
      "Pressure testing",
      "Tank certification",
      "Commercial kitchen audits",
    ],
  },
];

export const contractorStructureColumns = [
  {
    title: "Contract Standards",
    subtitle: "We maintain strict controls over all contractors:",
    points: [
      "Only DCD/ESMA-approved contractors are used",
      "Annual performance reviews conducted",
      "Safety training mandatory",
      "Original parts & certified products only",
    ],
  },
  {
    title: "Supplier Requirements",
    subtitle: "Suppliers undergo rigorous evaluation:",
    points: [
      "Quality checks",
      "Documentation review",
      "Material approval (AML)",
      "Performance scoring",
    ],
  },
];

export const riskManagementColumns = [
  {
    title: "Hazard Identification",
    points: [
      "Leak risks",
      "High-pressure system issues",
      "Aging infrastructure",
      "External construction risks",
    ],
  },
  {
    title: "Risk Controls",
    points: [
      "Preventive maintenance",
      "Emergency response protocols",
      "Smart meter monitoring",
      "Quarterly audits",
    ],
  },
  {
    title: "Incident Reporting & Learning",
    points: [
      "Transparent incident logs",
      "Root-cause analysis",
      "Team retraining",
      "Policy updates",
    ],
  },
];

export const governanceDownloads = [
  "Governance Policy Document",
  "HSE Manual",
  "Civil Defense Certificates",
  "ESMA Compliance Certificates",
  "Quality Manual",
  "Annual Compliance Calendar",
];

// ─── DownloadsResourcesLibrary page data ────────────────────────────────────

export const resourceLibraryFolders = [
  {
    title: "Customer Forms",
    documents: [
      {
        title: "Move-In / New Connection Form",
        desc: "For tenants & owners applying for a new gas connection.",
      },
      {
        title: "Move-Out / Disconnection Form",
        desc: "Required before vacating the unit.",
      },
      {
        title: "Refund Request Form",
        desc: "For security deposit refunds, overpayment refunds, and account closures.",
      },
      {
        title: "Meter Reading Submission Form (Manual)",
        desc: "Used if portal or smart meter is unavailable.",
      },
      {
        title: "Account Update Form",
        desc: "Update email, phone, tenancy documents, or contact person.",
      },
      {
        title: "Complaint & Feedback Form",
        desc: "Submit issues, service complaints, or feedback to improve our operations.",
      },
    ],
  },
  {
    title: "Billing & Tariffs",
    documents: [
      {
        title: "Tariff Sheet – Residential (AED 35 per m²)",
        desc: "Updated monthly according to market conditions.",
      },
      {
        title: "Commercial Tariff Booklet",
        desc: "Full rate card for restaurants, retail, hotels, industrial.",
      },
      {
        title: "Sample Gas Bill Explained",
        desc: "Visual breakdown of charges, fees, VAT, and readings.",
      },
      {
        title: "Payment Options & Banking Details",
        desc: "Accepted payment channels, online security guidelines, and timing.",
      },
    ],
  },
  {
    title: "Safety & Compliance",
    documents: [
      {
        title: "Gas Safety Guide (PDF)",
        desc: "Quick guide for residential users.",
      },
      {
        title: "Emergency Procedures Sheet",
        desc: "Step-by-step emergency action guide.",
      },
      {
        title: "Commercial Kitchen Safety Checklist",
        desc: "Quick guide for facility managers.",
      },
      {
        title: "Annual Inspection Service Report",
        desc: "Template for post-inspection documentation.",
      },
    ],
  },
  {
    title: "Technical Manuals",
    documents: [
      {
        title: "Gas Meter Installation Manual",
        desc: "Technical guide for meter setup and calibration.",
      },
      {
        title: "Pressure Testing Procedures",
        desc: "Step-by-step pressure testing guidelines.",
      },
      {
        title: "Smart Meter User Guide",
        desc: "How to read, manage, and troubleshoot smart meters.",
      },
      {
        title: "Pipeline Inspection Checklist",
        desc: "Field reference for technicians.",
      },
    ],
  },
  {
    title: "Developer Resources",
    documents: [
      {
        title: "Developer Partnership Agreement Template",
        desc: "Standard agreement for new building projects.",
      },
      {
        title: "Gas Network Design Guidelines",
        desc: "Specifications for new developments.",
      },
      {
        title: "Bulk Metering & Sub-Metering Guide",
        desc: "Setup and billing architecture for multi-tenant buildings.",
      },
      {
        title: "Authority NOC Checklist",
        desc: "Required documents for project approvals.",
      },
    ],
  },
  {
    title: "Policies & Legal Documents",
    documents: [
      {
        title: "Terms & Conditions of Service",
        desc: "Full service agreement for all GASIS customers.",
      },
      {
        title: "Privacy Policy",
        desc: "How we handle your personal data.",
      },
      {
        title: "Refund & Cancellation Policy",
        desc: "Conditions for refunds and service termination.",
      },
      {
        title: "Data Retention Policy",
        desc: "PDPL-compliant data management guidelines.",
      },
    ],
  },
  {
    title: "Corporate Documents",
    documents: [
      {
        title: "Trade License",
        desc: "Official GASIS trade license copy.",
      },
      {
        title: "DCD Compliance Certificates",
        desc: "Dubai Civil Defense certification.",
      },
      {
        title: "ESMA Conformity Certificates",
        desc: "Emirates standards compliance certification.",
      },
      {
        title: "VAT Registration Certificate",
        desc: "Federal Tax Authority VAT registration.",
      },
    ],
  },
  {
    title: "Marketing & Brochures",
    documents: [
      {
        title: "GASIS Company Profile",
        desc: "Overview of our services, history, and team.",
      },
      {
        title: "Residential Services Brochure",
        desc: "Full guide to personal gas services.",
      },
      {
        title: "Business Solutions Brochure",
        desc: "Corporate and commercial gas solutions.",
      },
      {
        title: "Partnership & Developer Brochure",
        desc: "How GASIS works with developers and OAs.",
      },
    ],
  },
];

// {
//   title: 'title',
//   desc: 'desc'
// },
